<avla-modal [name]="modalName" type="right"
    [icon]="{ type: 'class', icon: 'close', class: 'material-symbols-rounded' }" [onClose]="reInit.bind(this)">
    <div class="avla_modal_section__header text-center text-dark-gray mt-20">
        <img *ngIf="isSearch || isOk && isConfirm" class="mx-auto" src="assets/svg/stacked_email_blue.svg" alt="ícono de correo electrónico apilado">
        <img *ngIf="!isOk && isConfirm" class="mx-auto" src="assets/svg/stacked_email_red.svg" alt="ícono de correo electrónico apilado">
        <h5 *ngIf="isSearch || isConfirm" class="text-2xl font-semibold mt-11">
            Recuperar email
        </h5>
        <p *ngIf="isSearch" class="mt-2 mb-11 font-light text-m">Ingresar información solicitada</p>
        <p *ngIf="isConfirm && isOk" class="mt-11 mb-8 font-medium text-lg text-light-blue">Verifica tu correo electrónico actual. Si es incorrecto, actualízalo antes de presionar “Confirmar”</p>
        <p *ngIf="!isOk && isConfirm" class="mt-11 mb-8 font-medium text-lg text-fail">Este correo ya se encuentra asignado a otro usuario, por favor usar otro correo</p>
        <p *ngIf="isConfirm" class="mb-8 font-medium text-lg">Su email actual es:</p>
    </div>
    <div class="avla_modal_section__body mx-auto" [ngClass]="{'max-h-[70vh] overflow-y-scroll pb-40': height < 900}">
        <form *ngIf="isSearch" [formGroup]="recoverEmailForm" class="flex flex-col gap-8 w-[80%] mx-auto">
            <avla-input 
                class="avla-input-focus" 
                [form]="recoverEmailForm" 
                id="idOrganizationModal" 
                type="text"
                label="ID Organización" 
                [required]="true"
                errorMessage="Ingrese ID organización"
            >
            </avla-input>
            <avla-input 
                class="avla-input-focus" 
                [form]="recoverEmailForm" 
                id="userModal" 
                type="text"
                label="Usuario"
                [required]="true"
                errorMessage="Ingrese usuario"
            >
            </avla-input>
            <avla-input 
                class="avla-input-focus" 
                [form]="recoverEmailForm"
                id="passwordModal" 
                [icons]="{
                    type: 'class',
                    icon: 'visibility_off',
                    change: 'visibility',
                    class: 'material-symbols-rounded'
                    }" 
                type="password" 
                label="Contraseña" 
                [required]="true"
                errorMessage="Ingrese contraseña"
            >
            </avla-input>
            <div *ngIf="!hiddenV2" class="input-group mx-auto">
                <re-captcha id="token" name="token" #recaptcha="ngModel" [ngModelOptions]="{standalone: true}" [(ngModel)]="token" required [class.is-invalid]="recaptcha.invalid && (recaptcha.dirty || recaptcha.touched)"></re-captcha>
            </div>
            <avla-button
                class="mx-auto avla-button-blue"
                theme="primary"
                [disabled]="searchIsDisabled"
                label="Buscar"
                [icon]="{
                    type: 'class',
                    icon: 'search',
                    class: 'material-symbols-rounded',
                    position: 'left'
                }"
                (click)="search()"
            >
            </avla-button>
        </form>
        <form *ngIf="isConfirm" [formGroup]="recoverEmailForm" class="flex flex-col gap-8 w-[80%] mx-auto">
            <avla-input 
                [ngClass]="{'focus': recoverEmailForm.get('emailModal').value != ''}"
                class="avla-input-focus" 
                [form]="recoverEmailForm" 
                id="emailModal" 
                type="text"
                label="Email" 
                [required]="true"
                errorMessage="Ingrese email"
                [tooltip]="toolTip"
                [icons]="{
                    type: 'class',
                    icon: recoverEmailForm.get('emailModal').valid ? '' : 'info',
                    class: 'material-symbols-rounded'
                }"
            >
            </avla-input>
            <div *ngIf="!hiddenV2" class="input-group mx-auto">
                <re-captcha id="token" name="token" #recaptcha="ngModel" [ngModelOptions]="{standalone: true}" [(ngModel)]="token" required [class.is-invalid]="recaptcha.invalid && (recaptcha.dirty || recaptcha.touched)"></re-captcha>
            </div>
            <avla-button
                class="mx-auto avla-button-purple"
                theme="primary"
                [disabled]="confirmEmailIsDisabled"
                label="Confirmar"
                (click)="confirmEmail()"
            >
            </avla-button>
            <p class="text-dark-gray text-center">Importante: Asegúrate de registrar el email de uso frecuente, ya que a ese correo llegarán las pólizas emitidas</p>
        </form>
        <div *ngIf="isOk && !isConfirm" class="text-center flex flex-col gap-11">
            <span class="material-symbols-outlined text-gray-2 icon-task_alt">
                task_alt
            </span>
            <h5 class="text-2xl font-semibold text-light-blue">¡Actualizado!</h5>
            <p class="text-lg text-dark-gray">Ya tienes actualizado tu usuario</p>
            <avla-button
                class="mx-auto avla-button-purple"
                theme="primary"
                label="Continuar"
                (click)="closeModal()"
            >
            </avla-button>
        </div>
    </div>
</avla-modal>